export default __webpack_public_path__ + "2597fde0dcd998a73cdfc8006d11054d.png";